import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CancellationError } from "abweb/dto/async/CancellationError";
import { RemoteError } from "abweb/dto/exception/RemoteError";
import { AbWebServices } from "abweb/service/AbWebServices";
import { ASYNC_QUEUE_VIEW_FULL } from "abweb/service/rpc/StreamingRPCService";
import { TaskCanceled } from "abweb/service/rpc/TaskCanceled";
import { ErrorExtra, ErrorUtils } from "abweb/utils/ErrorUtils";
import { LogUtils } from "abweb/utils/log/LogUtils";
export class PollResponseHandler {
  constructor(responseParser = null, messageHandlers = null, view = false) {
    _defineProperty(this, "responseParser", void 0);
    _defineProperty(this, "messageHandlers", void 0);
    _defineProperty(this, "view", void 0);
    _defineProperty(this, "pendingResponses", []);
    // CAT-991: there were views where cancel happened with response.response being null, which resulted
    // in decrement not being invoked at all.  decrementOutstandingRequestCountInvoked is used to guard against this case.
    _defineProperty(this, "decrementOutstandingRequestCountInvoked", false);
    // There should be ONE AND ONLY ONE corresponding decrement (see this.decrementOutstandingRequestCountONCE())
    AbWebServices.getRPCService().outstandingRequestCounter.incrementOutstandingRequestCount();
    this.responseParser = responseParser;
    this.messageHandlers = messageHandlers;
    this.view = view;
  }
  handleLaunchResponse(task, response, resolve, reject) {
    this.finishResponse(response);
    this.task = task;
    this.resolve = resolve;
    this.reject = reject;
    this.pendingResponses.forEach(this.handleResponse.bind(this));
    this.pendingResponses = [];
  }
  handlePollResponse(response) {
    this.finishResponse(response);
    if (!this.task) {
      // Elliot said this doesn't matter anymore...
      // PollResponseHandler.LOG2.warn("Response polled before its launch response: " + response.taskId);
      this.pendingResponses.push(response);
      return false;
    } else {
      return this.handleResponse(response);
    }
  }
  handleResponse(response) {
    let complete = false;
    try {
      // views treat their response as the initial full message, so they need to process the response before any other messages
      if (this.view && response.response != null) {
        this.decrementOutstandingRequestCountONCE(/*"First view response: " + response.taskId*/);
        try {
          this.handleViewResponse(response.response);
          this.resolve(response.response);
        } catch (e) {
          this.reject(e);
        }
      }
      if (response.messages) {
        this.handleMessages(response.messages);
      }
      if (response.canceled) {
        complete = true;
        if (response.error) {
          this.reject(new CancellationError(response.error));
        } else {
          this.reject(new TaskCanceled(response.taskId));
        }
      }
      if (response.error) {
        complete = true;
        const remoteError = new RemoteError(response.error.message, null, null, response.error);
        ErrorUtils.setErrorExtra(remoteError, ErrorExtra.rpcServiceErrorUrl, this.task.url);
        if (this.task.callStack) {
          ErrorUtils.setErrorExtra(remoteError, ErrorExtra.rpcServiceErrorCallStack, this.task.callStack);
        }
        this.reject(remoteError);
      } else if (!this.view && (response.response != null || response.done)) {
        complete = true;
        this.resolve(response.response);
      }
    } finally {
      if (complete) {
        this.decrementOutstandingRequestCountONCE(/*response.taskId*/);
      }
    }
    return complete;
  }

  // Note increment happens in constructor.  As such, can only decrement once per lifetime of PollResponseHandler
  // instance, regardless of number of times responses come through that
  // want to decrement (first view response, then any subsequent error responses, cancellation responses, ...)
  decrementOutstandingRequestCountONCE(/*taskId: string*/
  ) {
    if (!this.decrementOutstandingRequestCountInvoked) {
      // console.error("PollResponseHandler: Decrementing for taskId: " + taskId);
      AbWebServices.getRPCService().outstandingRequestCounter.decrementOutstandingRequestCount();
      this.decrementOutstandingRequestCountInvoked = true;
    }
  }
  handleMessages(messages) {
    if (messages && this.messageHandlers) {
      for (let message of messages) {
        if (this.messageHandlers[message.queueName]) {
          this.messageHandlers[message.queueName](message.message);
        } else {
          PollResponseHandler.LOG2.warn("No handler for queue: " + message.queueName);
        }
      }
    }
  }
  handleViewResponse(response) {
    if (this.messageHandlers) {
      let handler = this.messageHandlers[ASYNC_QUEUE_VIEW_FULL];
      if (handler) {
        handler(response);
      }
    }
  }
  finishResponse(response) {
    response.finish(this.responseParser, this.messageHandlers);
  }
}
_defineProperty(PollResponseHandler, "LOG2", LogUtils.getLogger(__filename));
//# sourceMappingURL=PollResponseHandler.js.map
